<template>
  <div>
    <HelpTip v-bind="labelInfo"></HelpTip>
    <van-field
      class="date-time-picker work-temp-form-item"
      readonly
      clickable
      :value="timeText"
      :name="id"
      :rules="[
        {
          required: required,
          message: languages.smartOrderPleaseChoose + label
        }
      ]"
      @click="showDatePicker"
      right-icon="underway-o"
      :placeholder="placeholder || ''"
    >
    </van-field>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="time"
        :type="customKey.type"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        class="time-picker"
        :class="{ hideOtherColumn: customKey.type === 'year' }"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
import workTemp from '@mixins/officialSupport/workTemp';
import { timeFormatType } from '@configs/officialSupport/workTemp';
const formatTime = (date, fmt) => {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  }
  return fmt;
};

export default {
  name: 'TempInput',
  mixins: [workTemp],
  props: {
    customKey: {
      type: Object,
      default: () => ({
        type: 'year-month'
      })
    }
  },
  data() {
    return {
      time: '',
      timeValue: null,
      showPicker: false,
      maxDate: new Date()
    };
  },
  computed: {
    timeText() {
      if (!this.timeValue) {
        this.formData[this.id] = '';
        return '';
      }
      const time = formatTime(
        this.timeValue,
        timeFormatType[this.customKey.type]
      );
      this.formData[this.id] = time;
      return time;
    }
  },
  methods: {
    showDatePicker() {
      this.time = this.timeValue;
      this.$nextTick(() => {
        this.showPicker = true;
      });
    },
    onConfirm() {
      this.timeValue = this.time;
      this.$nextTick(() => {
        this.showPicker = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
.date-time-picker {
  ::v-deep .van-field__value {
    position: relative;
    font-size: 16px;
    color: var(--text-color);
  }
  ::v-deep .van-field__body {
    width: 100%;
    height: 64px;
    padding: 0 17px 0 20px;
    background-color: var(--block-bg-light-color);
    border-radius: var(--border-radius);
    box-sizing: border-box;
    border: 1px solid var(--border-color);
    color: var(--text-color);
  }
  ::v-deep .van-field__control {
    font-size: inherit;
    color: inherit;
  }

  ::v-deep .van-field__right-icon .van-icon {
    font-size: 24px;
  }

  .placeholder-style {
    color: var(--placeholder-color) !important;
  }
}
.time-picker.hideOtherColumn {
  ::v-deep .van-picker-column {
    display: none;
  }
  ::v-deep .van-picker-column:first-child {
    display: block;
  }
}
</style>
